export const PDP_FBT_FLAG = 'PCC_PDPFBTFeature';
export const DEALER_USER_SHARED_LIST_FLAG =
  'PCC_DealerUserSharedSavedListsFlag';
export const PCC_PDP_LUCID_FLAG = 'PCCPDPLucidFlag';
export const PCC_NAVIGATION_HEADER_SUBHEADER_MENU_FLAG =
  'PCCNavigationHeaderSubheaderMenuFlag';
export const PCC_PDP_LUCID_TAX_DISCLAIMER = 'PCC_TaxInformationMessagesFlag';
export const SIS_TO_CART_FALLBACK_FEATURE_FLAG =
  'PCC_SISToCartFallbackFeatureFlag';
export const PRIVACY_POLICY_FLAG = 'PCC_ECTPrivacyPolicy';
export const TERMS_CONDITIONS_FEATURE_FLAG = 'PCC_ECTTermsAndConditions';
export const CAT_LEGAL_TERMS_FLAG = 'PCC_FooterLegalTermsLinkRedirection';
export const PCC_CAL_FOR_QUOTE_FEATURE_FLAG = 'PCC_CalForQuoteFeatureFlag';
export const PCC_CREATE_QUOTE_BUTTON_POPOVER_TOOLTIP_FLAG =
  'PCC_CreateQuoteButtonPopoverTooltipFlag';
export const PCC_HEADLESS_SHOPPING_CART_FLAG = 'PCC_HeadlessBlocksShoppingCart';
export const PCC_HEADLESS_ASSETLANDINGPAGE = 'PCC_Headless_AssetLandingPage';
export const PCC_LUCID_SOLR_ADDEQUIPMENTCOMPONENT_FLAG =
  'PCCLucidSolrAddEquipmentComponentFlag';
export const PCC_HEADLESS_SEARCH_FLAG = 'PCC_HeadlessBlocksShoppingCart';
export const PCC_NAVIGATION_MENU_UPDATES = 'PCCNavigationMenuUpdatesFlag';
export const EMERGENGY_MESSAGE_FLAG = 'PCC_ECTEmergencyMessageFlag';
export const PCC_HEADLESS_SAVED_LISTS_PAGE = 'PCCHeadlessSavedListsPage';
export const PCC_HEADLESS_ORDER_STATUS_PAGE = 'PCCHeadlessOrderStatusPage';
export const PCC_HEADLESS_ORDER_HISTORY_PAGE =
  'PCC_HeadlessOrdHistorySearchPageFlag';
export const PCC_MACHINE_DETAILS_FLAG = 'PCCMachineDetailsFlag';
export const PCC_HEADLESS_PDP_FLAG = 'PCC_HeadlessBlocksPDP_TopSection';
export const PCC_PARTS_DIAGRAM_URL_FLAG = 'PCCPartsDiagramUrlFlag';
export const PCC_DEALER_ALL_ORDER_HISTORY_FLAG =
  'PCC_DealerUserAllOrderHistorySearchFlag';
export const PCC_MACHINE_SUMMARY_FLAG = 'PCCEquipmentComponentFlag';
export const PCC_UPDATE_USEESPOTS_HOOK_FLAG = 'PCC_Update_useEspots_Hook_Flag';
export const PCC_DEALER_LOCATION_FLAG = 'PCC_ECTDealerLocationFlag';
export const PCC_PS_TITLE_UPDATES = 'PCC_PaymentAndSummary_TitleUpdates';
export const PCC_EDITPHONENUMBERFORMAT = 'PCC_EditPhoneNumberFormat';
export const PCC_PS_REPOSITIONING_UPDATES =
  'PCC_PaymentAndSummary_RepositioningOfPaymentSection';
export const PCC_PS_PLACING_ORDER_UPDATES =
  'PCC_PaymentAndSummary_PlacingOrderUpdates';
export const PCC_PS_ITEMS_OPTIMIZATION =
  'PCC_PaymentAndSummary_ItemsInYourOrderOptimization';
export const PCC_PS_BILLING_SECTION_DRAWERS =
  'PCC_PaymentAndSummary_BillingSectionDrawers';
export const PCC_PUD_TITLE_UPDATES = 'PCC_PickupAndDelivery_TitlecaseUpdates';
export const PCC_VIEW_ALL_LUCID_MARKETING_PAGE =
  'PCC_ViewAllLucidMarketingPage';
export const PCC_PUD_CONTACT_UPDATES =
  'PCC_PickupAndDelivery_ContactInformationUpdates';
export const PCC_PUD_STORE_LOCATION = 'PCC_PickupAndDropbox_StoreLocation';
export const PCC_RANGE_SLIDER_SEARCH_PAGE = 'PCC_RangeSliderSearchPage';
export const PCC_HideMethodsForNoviceCustomers =
  'PCC_HideMethodsForNoviceCustomers';
export const PCC_PUD_SECTION_DRAWERS =
  'PCC_PickupAndDropbox_PickupPriorityAndDropboxUpdates';
export const PCC_PS_HIDE_ESPOTS_MOBILE =
  'PCC_PaymentAndSummary_eSpotHidingMobileView';
export const PCC_PUD_HIDE_ESPOTS_MOBILE =
  'PCC_PickupAndDelivery_eSpotHidingMobileView';
export const PCC_CHECKOUT_PAGES_DRAWERS_MOBILE =
  'PCC_CheckoutPages_DrawersMobileView';
export const PCC_HEADLESS_QUOTES_DETAILS_PAGE =
  'PCC_HeadlessPendingQuoteDetailsFlag';
export const PCC_MARKETINGCONSENT_PUD_FLAG = 'PCC_MarketingConsentPUDFlag';
export const PCC_SKIP_CREATE_QUOTE_PO_VALIDATION =
  'PCC_SkipCreateQuotePOValidation';
export const PCC_HEADLESS_BLOCKS_RECENTLY_VIEWED_PAGE =
  'PCCHeadlessBlocksRecentlyViewedPage';
export const PCC_HEADLESS_BLOCKS_CATEGORY_PAGES =
  'PCC_HeadlessBlocksCategoryPages';
export const PCC_REFRESH_PARTS_AVAILABILITY_ON_QUOTE =
  'PCC_RefreshPartsAvailabilityOnQuote';
export const PCC_CMCYOUTUBE_WIDGET = 'PCC_CmcYoutube_Widget';
export const PCC_HEADLESS_BLOCKS_CORE_TRACKING =
  'pcc-release-headless-core-tracking-page';
